import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Button from "../button";

const CarHuddleInsuranceReviewCard = ({ insuranceData, formData}) => {
    const { huddleLink = ""} = formData || {};
    const handleClick = () => {
        if (huddleLink) {
            window.open(huddleLink, "_blank");
        }
    };
    if (!insuranceData) return null;

    const { cardData } = insuranceData || {};
    const { title = "", subTitle = "", ctaText = "", iconUrl = "" } = cardData || {};

    return (
        <div styleName={"styles.reviewCard"}>
            <img src={iconUrl} alt="Review Illustration" />
            <p styleName={"styles.heading"}>{title}</p>
            <p styleName={"styles.subHeading"}>{subTitle}</p>
            <a onClick={handleClick}>
                <Button
                    text={ctaText}
                    showArrow={true}
                    customStyle={["inter-btn-design"]}
                />
            </a>
        </div>
    );
};

CarHuddleInsuranceReviewCard.propTypes = {
    insuranceData: PropTypes.object,
    formData: PropTypes.object
};

export default CarHuddleInsuranceReviewCard;
